package com.essntl.features.supplier.ui.allsuppliers

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.supplier.domain.model.SupplierFilterOptions
import com.essntl.features.supplier.domain.model.SupplierModel

data class AllSuppliersState(
    val getAllSuppliers: PaginationState<SupplierModel> = PaginationState(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val filterOptions: SupplierFilterOptions = SupplierFilterOptions(),
)
